module.exports = __webpack_public_path__ + "img/8ne.d0392657.svg";